export enum PreviewProduct {
  ACTIVATION_POPUP = "activationPopup",
  NEWSLETTER_FORMS = "newsletterForms"
}
